export default __webpack_public_path__ + "static/media/billing-icon.a5a47180.svg";